<template>
	<div data-tour-scope="dispatch-orders">
		<v-main>
			<v-container fluid>
				<v-card outlined elevation-0>
					<v-toolbar flat>
						<v-toolbar-title>Smistamento Ordini</v-toolbar-title>
						<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
							<v-icon left>mdi-school-outline</v-icon>
							Tutorial guidato
						</v-btn>
						<v-spacer></v-spacer>
						<span v-if="filters.created_at.length === 0" class="text-caption grey--text mr-2">Ultimi {{ getDays }} giorni</span>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon @click="resetFilters" :disabled="getLoading || !hasActiveFilters" v-on="on" data-tour="reset">
									<v-icon>mdi-filter-remove-outline</v-icon>
								</v-btn>
							</template>
							<span>Reimposta filtri</span>
						</v-tooltip>
						<v-btn icon @click="refresh" :loading="getLoading">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
					</v-toolbar>

					<v-divider></v-divider>


					<v-card-text>
						<v-row>
							<v-col cols="12" md="3" data-tour="search">
								<v-text-field
									v-model="filters.search"
									outlined
									dense
									clearable
									label="Cerca ordine o cliente"
									hide-details
									prepend-inner-icon="mdi-magnify"
									@input="onFilterChange"
									@click:clear="onSearchClear"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="3" data-tour="date">
								<v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" dense>
									<template v-slot:activator="{ on }">
										<v-text-field
											:value="computedDateLabel"
											v-on="on"
											outlined
											dense
											clearable
											@click:clear="clearDate"
											label="Data ordine"
											hide-details
											prepend-inner-icon="mdi-calendar"
										></v-text-field>
									</template>
									<v-date-picker :value="filters.created_at" @input="onDateInput" range></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3" data-tour="platform">
								<v-select
									v-model="filters.platform"
									:items="platformOptions"
									item-text="text"
									item-value="value"
									outlined
									multiple
									dense
									clearable
									label="Platform"
									hide-details
									@change="onFilterChange"
								>
									<template v-slot:item="{ item }">
										<img :src="getImageMarketplace(item.value)" :alt="item.text" width="18" class="mr-2" />
										{{ item.text }}
									</template>
									<template v-slot:selection="{ item, parent }">
										<v-chip small close class="my-1" @click:close="parent.selectItem(item)">
											<img :src="getImageMarketplace(item.value)" :alt="item.text" width="14" class="mr-1" />
											{{ item.text }}
										</v-chip>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" md="3" data-tour="status">
								<v-select
									v-model="filters.status"
									:items="statusOptions"
									item-text="text"
									item-value="value"
									outlined
									multiple
									dense
									clearable
									label="Stati"
									hide-details
									@change="onFilterChange"
								>
									<template v-slot:item="{ item }">
										<v-avatar size="10" :color="item.color" class="mr-2"></v-avatar>
										{{ item.text }}
									</template>
									<template v-slot:selection="{ item, parent }">
										<v-chip small close class="my-1" @click:close="parent.selectItem(item)">
											<v-avatar size="8" :color="item.color" class="mr-1"></v-avatar>
											{{ item.text }}
										</v-chip>
									</template>
								</v-select>
							</v-col>
						</v-row>
					</v-card-text>

					<v-divider></v-divider>

					<div class="d-flex flex-wrap px-4 pt-3 pb-1" data-tour="tabs">
						<div v-for="(tab, index) in tabs" :key="tab._id" class="dispatch-tab mr-2 mb-2 px-4 py-2" :style="tabStyle(tab, index)" @click="activeTab = index">
							<span v-if="activeTab !== index" class="dispatch-tab-dot" :style="{ backgroundColor: tab.color }"></span>
							{{ tab.label }} ({{ (tab.pagination && tab.pagination.total) || 0 }})
						</div>
					</div>

					<!-- le tabelle nascono dopo il primo caricamento: con il totale ancora a zero
					     v-data-table riporterebbe a 1 la pagina letta dall'URL -->
					<div v-if="caricato">
						<div v-for="(tab, index) in tabs" :key="tab._id" v-show="activeTab === index">
							<v-data-table
								data-tour="table"
								:headers="headers"
								:items="tab.orders"
								:loading="getLoading"
								:options.sync="tableOptions"
								:server-items-length="tab.pagination.total"
								:footer-props="{ 'items-per-page-options': perPageOptions }"
								:expanded="expanded"
								show-expand
								item-key="_id"
								disable-sort
								no-data-text="Nessun ordine da smistare"
								:hide-default-header="mobileCards"
								:class="{ 'table-cards': mobileCards }"
							>
								<!-- telefono: ogni riga diventa una card chiave/valore (slot body solo sotto i 769px,
								     su desktop restano gli slot item.* qui sotto) -->
								<template v-if="mobileCards" v-slot:body="{ items }">
									<tbody class="dispatch-cards">
										<tr v-if="!items.length">
											<td :colspan="headers.length" class="px-3 py-1">
												<div class="grey--text text-center py-4">Nessun ordine da smistare</div>
											</td>
										</tr>
										<tr v-for="item in items" :key="item._id">
											<td :colspan="headers.length" class="px-3 py-1">
												<key-value-card :title="titoloCard(item)" :fields="campiCard(item)">
													<template v-slot:actions>
														<v-btn icon small color="primary" data-tour="expand" :title="isItemExpanded(item) ? 'Chiudi' : 'Mostra prodotti'" @click="toggleExpand(item)">
															<v-icon>{{ isItemExpanded(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
														</v-btn>
													</template>
													<template v-slot:top>
														<div class="d-flex align-center flex-wrap mb-2">
															<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" width="20" class="mr-2" />
															<img v-if="item.ShippingAddress && item.ShippingAddress.Country" :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" width="16" class="mr-2" />
															<v-chip
																v-if="item.StatusOrder && item.StatusOrder._id"
																small
																class="mr-2"
																:color="getStatusColor(item.StatusOrder)"
																:text-color="isDarkColor(getStatusColor(item.StatusOrder)) ? '#FFFFFF' : '#000000'"
															>
																{{ item.StatusOrder.value }}
															</v-chip>
															<v-menu offset-y :close-on-content-click="true">
																<template v-slot:activator="{ on }">
																	<v-chip v-if="item.Tag && item.Tag.color" small :style="tagChipStyle(item.Tag)" v-on="on" data-tour="tag">{{ item.Tag.label }}</v-chip>
																	<v-chip v-else small outlined v-on="on" data-tour="tag">Nessun tag</v-chip>
																</template>
																<v-list dense data-tour="tag-list">
																	<v-list-item v-for="tag in getTags" :key="tag._id" @click="changeTag(item, tag)">
																		<v-chip small :style="tagChipStyle(tag)">{{ tag.label }}</v-chip>
																	</v-list-item>
																	<v-list-item @click="changeTag(item, null)">
																		<v-chip small outlined>Nessun tag</v-chip>
																	</v-list-item>
																</v-list>
															</v-menu>
														</div>
													</template>
													<div data-tour="packing">
														<template v-if="hasActivePackingList(item)">
															<div class="text-caption mb-1">In carico a: {{ packingListOperator(item) }}</div>
															<v-btn small block color="primary" @click="openEdit(item)">Apri Packing List</v-btn>
														</template>
														<template v-else>
															<v-btn small block color="primary" @click="openQuickStart(item)">Avvia Packing List</v-btn>
														</template>
													</div>
													<template v-if="isItemExpanded(item)">
														<div class="dispatch-section mt-3">Prodotti</div>
														<div v-for="(prod, prodIndex) in item.Items" :key="prodIndex" class="dispatch-line d-flex">
															<v-img :src="getProductImage(prod, item)" max-width="48" max-height="48" contain class="mr-3 flex-grow-0">
																<template #placeholder>
																	<v-img :src="require('@/assets/images/picture.svg')" max-width="48" max-height="48" contain />
																</template>
															</v-img>
															<div class="flex-grow-1" style="min-width: 0">
																<div class="font-weight-medium">{{ prod.Title || 'Prodotto' }}</div>
																<div class="dispatch-kv">
																	<span>SKU</span><span>{{ prod.SKU || '-' }}</span>
																</div>
																<div class="dispatch-kv">
																	<span>Quantità</span><span class="font-weight-bold">{{ prod.QuantityPurchased }}</span>
																</div>
																<div class="dispatch-kv">
																	<span>Prezzo</span><span>{{ prod.TransactionPrice }} {{ item.Currency }}</span>
																</div>
															</div>
														</div>
														<div v-if="!(item.Items || []).length" class="grey--text">Nessun prodotto</div>
													</template>
												</key-value-card>
											</td>
										</tr>
									</tbody>
								</template>
								<!-- espansione gestita a mano (toggleExpand/isItemExpanded), non tramite il callback
						 "expand" del gruppo interno di Vuetify: sullo stesso pattern di v-tabs/v-tabs-items
						 gia' sostituiti in questa pagina, quel meccanismo si e' rivelato inaffidabile qui -->
								<template v-slot:item.data-table-expand="{ item }">
									<v-btn icon small @click="toggleExpand(item)" data-tour="expand">
										<v-icon>{{ isItemExpanded(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
									</v-btn>
								</template>
								<template v-slot:item.created_at="{ item }">
									{{ item.created_at ? new Date(item.created_at).toLocaleDateString('it-IT') : '' }}
								</template>
								<template v-slot:item.buyer="{ item }">
									{{ buyerName(item) }}
								</template>
								<template v-slot:item.Platform="{ item }">
									<div class="d-flex align-center">
										<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" width="20" class="mr-2" />
										<v-avatar v-if="item.ShippingAddress && item.ShippingAddress.Country" size="16px" tile class="mr-2">
											<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" />
										</v-avatar>
										<span>{{ item.Platform }}</span>
									</div>
								</template>
								<template v-slot:item.StatusOrder="{ item }">
									<v-chip
										v-if="item.StatusOrder && item.StatusOrder._id"
										small
										:color="getStatusColor(item.StatusOrder)"
										:text-color="isDarkColor(getStatusColor(item.StatusOrder)) ? '#FFFFFF' : '#000000'"
									>
										{{ item.StatusOrder.value }}
									</v-chip>
								</template>
								<template v-slot:item.Total="{ item }"> {{ (+item.Total || 0).toFixed(2) }} &euro; </template>
								<template v-slot:item.Tag="{ item }">
									<v-menu offset-y :close-on-content-click="true">
										<template v-slot:activator="{ on }">
											<v-chip v-if="item.Tag && item.Tag.color" small :style="tagChipStyle(item.Tag)" v-on="on" data-tour="tag">{{ item.Tag.label }}</v-chip>
											<v-chip v-else small outlined v-on="on" data-tour="tag">Nessun tag</v-chip>
										</template>
										<v-list dense data-tour="tag-list">
											<v-list-item v-for="tag in getTags" :key="tag._id" @click="changeTag(item, tag)">
												<v-chip small :style="tagChipStyle(tag)">{{ tag.label }}</v-chip>
											</v-list-item>
											<v-list-item @click="changeTag(item, null)">
												<v-chip small outlined>Nessun tag</v-chip>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>
								<template v-slot:item.packing_list="{ item }">
									<div data-tour="packing">
										<template v-if="hasActivePackingList(item)">
											<div class="text-caption mb-1">In carico a: {{ packingListOperator(item) }}</div>
											<v-btn small color="primary" @click="openEdit(item)">Apri Packing List</v-btn>
										</template>
										<template v-else>
											<v-btn small color="primary" @click="openQuickStart(item)">Avvia Packing List</v-btn>
										</template>
									</div>
								</template>
								<template v-slot:expanded-item="{ headers, item }">
									<td :colspan="headers.length" class="pa-0">
										<v-sheet class="ma-2 pa-2" color="#f5f5f5" rounded>
											<v-simple-table dense>
												<thead>
													<tr>
														<th>Immagine</th>
														<th>SKU</th>
														<th>Titolo</th>
														<th>Quantità</th>
														<th>Prezzo</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(prod, prodIndex) in item.Items" :key="prodIndex">
														<td>
															<v-img :src="getProductImage(prod, item)" max-width="64" max-height="64" contain class="my-1">
																<template #placeholder>
																	<v-img :src="require('@/assets/images/picture.svg')" max-width="64" max-height="64" contain />
																</template>
															</v-img>
														</td>
														<td>{{ prod.SKU }}</td>
														<td>{{ prod.Title }}</td>
														<td>{{ prod.QuantityPurchased }}</td>
														<td>{{ prod.TransactionPrice }} {{ item.Currency }}</td>
													</tr>
												</tbody>
											</v-simple-table>
										</v-sheet>
									</td>
								</template>
							</v-data-table>
						</div>
					</div>
				</v-card>

			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from 'axios';
import moment from 'moment';
import { isDarkColor } from '../../Helper';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { openWithReturn } from '@/components/core/pageReturn';
import { settingsToQuery, settingsFromQuery } from '@/components/core/list/listRouteState';
import { rememberListRoute } from '@/components/core/list/listReturn';
import { useTour } from '@/components/core/tour/useTour';
import { createDispatchOrdersTourSteps, stopDispatchOrdersTour } from './dispatch-orders-tour';

// stessi id di config/constants.js (DEFAULT_INCLUDED_STATUS_IDS in dispatch-orders/controller.js
// sul backend): e' il default applicato quando filters.status e' vuoto — Spedito, Spedito
// parzialmente, In preparazione. Filtro per INCLUSIONE (non piu' per esclusione).
const DEFAULT_INCLUDED_STATUS_IDS = [
	'60deb72a6fee57191fa7114f', // Spedito
	'60deb7806fee57191fa71153', // Spedito parzialmente
	'60deb7436fee57191fa71150', // In preparazione
];

const PER_PAGE_OPTIONS = [15, 25, 50, 100];
// filtri della board nell'URL (stesso formato delle liste: listRouteState)
const QUERY_FILTERS = { platform: 'array', created_at: 'array', status: 'array' };
const QUERY_DEFAULTS = {
	search: '',
	filters: { platform: [], created_at: [], status: [...DEFAULT_INCLUDED_STATUS_IDS] },
	options: { page: 1, itemsPerPage: 25, sortBy: [], sortDesc: [] },
};
// stato della board letto dall'URL: filtri, pagina, righe per pagina, tab (id del tag o 'untagged')
function statoDaQuery(query) {
	const st = settingsFromQuery(query, QUERY_DEFAULTS, QUERY_FILTERS, PER_PAGE_OPTIONS);
	return {
		filters: { ...st.filters, search: st.search },
		tableOptions: { page: st.options.page, itemsPerPage: st.options.itemsPerPage, sortBy: [], sortDesc: [] },
		tab: query.tab ? String(query.tab) : '',
	};
}

export default {
	name: 'DispatchOrdersIndex',
	components: { TourOverlay, KeyValueCard },
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createDispatchOrdersTourSteps(), { onStop: stopDispatchOrdersTour }),
		};
	},
	data() {
		const stato = statoDaQuery(this.$route.query);
		return {
			activeTab: 0,
			// tab chiesta dall'URL: si seleziona appena i tag sono caricati
			tabDaUrl: stato.tab,
			caricato: false,
			dateMenu: false,
			// status parte gia' valorizzato con il default (non aspetta il fetch di statusOptions,
			// che serve solo per etichette/colori): niente finestra in cui il filtro parte vuoto
			// per una corsa tra richieste al boot (es. su F5).
			filters: stato.filters,
			// footer standard di v-data-table (stesso pattern di order/Index.vue: options.sync +
			// server-items-length). Il backend applica pero' la stessa page/itemsPerPage a tutti i
			// branch (tag + senza tag) in un'unica richiesta, quindi tableOptions e' condiviso tra i
			// tab: cambiare pagina in un tab la cambia per tutti (nessuna paginazione indipendente).
			tableOptions: stato.tableOptions,
			perPageOptions: PER_PAGE_OPTIONS,
			// popolato in created() da services/getServiceFetchActive, stesso pattern di order/Index.vue:
			// solo le integrazioni realmente attive per il profilo, 'Store' sempre presente.
			platformOptions: [],
			expanded: [],
			// popolato in created() da statusorders/fetchLists: {text, value, color}
			statusOptions: [],
			// stesso ordine di order/Index.vue::headers (Data, Piattaforma, ID Ordine, Cliente, Status, Totale);
			// Tag e Packing List in coda perche' specifiche di questa board, assenti nell'index ordini classico.
			headers: [
				{ text: 'Data', value: 'created_at' },
				{ text: 'Piattaforma', value: 'Platform' },
				{ text: 'Ordine', value: 'OrderID' },
				{ text: '', value: 'data-table-expand', width: 40 },
				{ text: 'Cliente', value: 'buyer' },
				{ text: 'Stato', value: 'StatusOrder' },
				{ text: 'Pagamento', value: 'Checkout.PaymentMethods' },
				{ text: 'Spedizione', value: 'ShippingService.ShippingService' },
				{ text: 'Totale', value: 'Total' },
				{ text: 'Tag', value: 'Tag' },
				{ text: 'Packing List', value: 'packing_list', sortable: false },
			],
		};
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getTags: 'dispatchOrders/getTags',
			getUntagged: 'dispatchOrders/getUntagged',
			getDays: 'dispatchOrders/getDays',
			getLoading: 'dispatchOrders/getLoading',
			getUserName: 'profile/getName',
			getSetting: 'settings/getSetting',
			getLanguage: 'profile/getLanguage',
			getUrl: 'settings/getUrl',
			getToken: 'profile/getToken',
		}),
		// unifica i branch "per tag" e "senza tag" in un'unica lista, cosi' tab e tab-item
		// si scrivono una volta sola con un v-for invece di duplicare il markup della tabella.
		tabs() {
			return [
				...this.getTags.map(tag => ({ _id: tag._id, label: tag.label, color: tag.color, orders: tag.orders, pagination: tag.pagination })),
				{ _id: 'untagged', label: 'Senza tag', color: '#9e9e9e', orders: this.getUntagged.orders, pagination: this.getUntagged.pagination },
			];
		},
		computedDateLabel() {
			if (this.filters.created_at.length === 0) return '';
			if (this.filters.created_at.length === 1) return `Dal ${moment(this.filters.created_at[0]).format('DD/MM/YYYY')}`;
			return this.filters.created_at.map(value => moment(value).format('DD/MM/YYYY')).join(' ~ ');
		},
		// filters.status parte pre-popolato con l'inclusione di default (vedi created()), quindi
		// non conta come "filtro attivo" finche' l'utente non se ne discosta.
		hasActiveFilters() {
			const isDefaultStatus = this.filters.status.length === DEFAULT_INCLUDED_STATUS_IDS.length && this.filters.status.every(id => DEFAULT_INCLUDED_STATUS_IDS.includes(id));
			return this.filters.platform.length > 0 || this.filters.created_at.length > 0 || !isDefaultStatus || _.trim(this.filters.search).length > 0;
		},
	},
	async created() {
		this.debouncedSearch = _.debounce(this.applyFilters, 400);
		// filtri, pagina e tab arrivano dall'URL (data()): refresh e ritorno dalle pagine ripartono uguali
		this.syncRoute();
		// solo per etichette/colori nel select: filters.status e' gia' corretto a prescindere da questo fetch.
		// getSetting (colori stato) non e' garantito gia' caricato: a differenza di order/Index.vue
		// questa e' spesso la prima pagina visitata nella sessione (F5 diretto), quindi va richiesto
		// esplicitamente qui invece di assumere che un'altra vista l'abbia gia' popolato.
		Promise.all([this.fetchSetting(), this.fetchStatusOrder()]).then(([, statusResult]) => {
			const colorSettings = this.getSetting?.status_order || [];
			_.forEach(statusResult?.data || [], el => {
				const textStatus = _.find(el.trans, { lang: this.getLanguage });
				const colorSetting = _.find(colorSettings, { _id: el._id });
				this.statusOptions.push({ text: textStatus ? textStatus.value : el._id, value: el._id, color: colorSetting ? colorSetting.color : '#FFFFFF' });
			});
		});
		// piattaforme da mostrare nel filtro: solo le integrazioni attive per il profilo (stesso
		// elenco/servizi di order/Index.vue), 'Store' sempre presente.
		const PLATFORM_SERVICES = [
			{ service: 'mws', label: 'Amazon' },
			{ service: 'ebay', label: 'Ebay' },
			{ service: 'magento', label: 'Magento' },
			{ service: 'shopify', label: 'Shopify' },
			{ service: 'aliexpress', label: 'Aliexpress' },
			{ service: 'prestashop', label: 'Prestashop' },
			{ service: 'woocommerce', label: 'Woocommerce' },
		];
		this.fetchServiceactive(PLATFORM_SERVICES.map(p => p.service)).then(status => {
			const activePlatforms = PLATFORM_SERVICES.filter(p => (status || []).some(el => el.service === p.service && el.active === true)).map(p => ({
				text: p.label,
				value: p.label,
			}));
			this.platformOptions = [{ text: 'Store', value: 'Store' }, ...activePlatforms];
		});
		await this.fetchData({ filters: this.filters, page: this.tableOptions.page, itemsPerPage: this.tableOptions.itemsPerPage });
		this.caricato = true;
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
	},
	watch: {
		// all'apertura senza date la partenza e' oggi: si puo' poi cambiare o aggiungere la data di fine
		dateMenu(aperto) {
			if (aperto && this.filters.created_at.length === 0) {
				this.onDateInput([moment().format('YYYY-MM-DD')]);
			}
		},
		// footer standard di v-data-table: .sync riassegna sempre un nuovo oggetto (mai mutazione in
		// place), quindi un watcher non-deep basta e non si confonde con le mie mutazioni dirette
		// (applyFilters/resetFilters) che invece aggiornano solo tableOptions.page senza passare da qui.
		tableOptions(newVal, oldVal) {
			if (oldVal && newVal.page === oldVal.page && newVal.itemsPerPage === oldVal.itemsPerPage) return;
			this.syncRoute();
			this.fetchData({ days: this.getDays, filters: this.filters, page: newVal.page, itemsPerPage: newVal.itemsPerPage });
		},
		activeTab() {
			this.syncRoute();
		},
		// tag caricati: si seleziona la tab chiesta dall'URL (una volta sola)
		tabs(tabs) {
			if (!this.tabDaUrl) return;
			const index = tabs.findIndex(t => t._id === this.tabDaUrl);
			if (index !== -1) {
				this.activeTab = index;
				this.tabDaUrl = '';
			}
		},
		// navigazione esterna sulla stessa pagina (es. voce di menu senza parametri): si riparte dall'URL
		'$route.query'(query) {
			if (JSON.stringify(query) === JSON.stringify(this.queryCorrente())) return;
			const stato = statoDaQuery(query);
			this.filters = stato.filters;
			this.tabDaUrl = stato.tab;
			this.activeTab = 0;
			this.tableOptions = stato.tableOptions;
			this.fetchData({ days: this.getDays, filters: this.filters, page: stato.tableOptions.page, itemsPerPage: stato.tableOptions.itemsPerPage });
		},
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchData: 'dispatchOrders/asyncFetchData',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchSetting: 'settings/asyncFetchData',
			fetchServiceactive: 'services/getServiceFetchActive',
			updateSnackbar: 'settings/updateSnackbar',
		}),
		queryCorrente() {
			const query = settingsToQuery(
				{ search: _.trim(this.filters.search || ''), filters: this.filters, options: this.tableOptions },
				QUERY_DEFAULTS,
				QUERY_FILTERS,
			);
			const tab = this.tabs[this.activeTab];
			if (this.activeTab > 0 && tab) query.tab = tab._id;
			else if (this.tabDaUrl) query.tab = this.tabDaUrl;
			return query;
		},
		syncRoute() {
			const query = this.queryCorrente();
			if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
				this.$router.replace({ query }).catch(() => {});
			}
			rememberListRoute(this.$route.path, query);
		},
		refresh() {
			return this.fetchData({ days: this.getDays, filters: this.filters, page: this.tableOptions.page, itemsPerPage: this.tableOptions.itemsPerPage });
		},
		applyFilters() {
			this.activeTab = 0;
			this.tabDaUrl = '';
			this.tableOptions.page = 1;
			this.syncRoute();
			return this.fetchData({ days: this.getDays, filters: this.filters, page: 1, itemsPerPage: this.tableOptions.itemsPerPage });
		},
		// ad ogni cambio filtro la ricerca riparte da sola (debounced, istanziato in created(),
		// per non spammare richieste mentre l'utente sta ancora selezionando piu' voci in un select multiplo)
		onFilterChange() {
			this.debouncedSearch();
		},
		// la ricerca parte gia' con la sola data di partenza (dal giorno in poi), la seconda chiude l'intervallo
		onDateInput(value) {
			const dates = [...(value || [])].sort();
			this.filters.created_at = dates;
			if (dates.length === 2) this.dateMenu = false;
			this.onFilterChange();
		},
		resetFilters() {
			this.filters = { platform: [], created_at: [], status: [...DEFAULT_INCLUDED_STATUS_IDS], search: '' };
			return this.applyFilters();
		},
		clearDate() {
			this.filters.created_at = [];
			this.onFilterChange();
		},
		onSearchClear() {
			this.filters.search = '';
			this.onFilterChange();
		},
		// tab-tag come chip moderne: quando attiva lo sfondo si colora del colore del tag (con
		// contrasto testo calcolato); quando inattiva resta grigio chiaro con un pallino colorato
		// a fare da indicatore (vedi template, v-if="activeTab !== index").
		tabStyle(tag, index) {
			const isActive = this.activeTab === index;
			return {
				borderRadius: '8px',
				backgroundColor: isActive ? tag.color : '#F5F5F5',
				border: isActive ? `1px solid ${tag.color}` : '1px solid #E0E0E0',
				boxShadow: isActive ? '0 1px 4px rgba(0,0,0,0.15)' : 'none',
				color: isActive ? (isDarkColor(tag.color) ? '#FFFFFF' : '#000000') : '#000000',
			};
		},
		// titolo della card: id ordine + cliente
		titoloCard(item) {
			return [item.OrderID, this.buyerName(item)].filter(Boolean).join(' - ');
		},
		// coppie chiave/valore della card (vista telefono), stessi dati delle colonne desktop
		campiCard(item) {
			return [
				{ label: 'Data', value: item.created_at ? new Date(item.created_at).toLocaleDateString('it-IT') : '' },
				{ label: 'Piattaforma', value: item.Platform },
				{ label: 'Pagamento', value: _.get(item, 'Checkout.PaymentMethods') },
				{ label: 'Spedizione', value: _.get(item, 'ShippingService.ShippingService') },
				{ label: 'Totale', value: `${(+item.Total || 0).toFixed(2)} €`, strong: true },
			];
		},
		buyerName(item) {
			if (item.buyer && (item.buyer.name || item.buyer.lastname)) {
				return `${item.buyer.name || ''} ${item.buyer.lastname || ''}`.trim();
			}
			return 'N.D.';
		},
		// stesso stile chip usato in order/Index.vue per coerenza visiva
		tagChipStyle(tag) {
			return {
				backgroundColor: tag.color,
				color: isDarkColor(tag.color) ? '#FFFFFF' : '#000000',
			};
		},
		// stessa logica di order/Index.vue::getProductImage (richiede item.Items + item.itemsImages,
		// quest'ultimo popolato dal $lookup aggiunto in dispatch-orders/controller.js#runSearch)
		getProductImage(prod, order) {
			const placeholder = require('@/assets/images/picture.svg');
			const snapshot = prod.image || null;
			const entry = (order.itemsImages || []).find(it => it._id?.toString() === prod.ProductId?.toString());
			if (!entry || !entry.images || !entry.images.length) return snapshot || placeholder;
			if (prod.CatalogId) {
				const cat = prod.CatalogId.toString();
				const variantImg = entry.images.find(img => (img.variants || []).some(v => v?.toString() === cat));
				if (variantImg?.sizes?.[0]?.value) return variantImg.sizes[0].value;
			}
			return entry.images[0]?.sizes?.[0]?.value || snapshot || placeholder;
		},
		// stesso endpoint/payload di order/Index.vue::changeStatus (qui il profilo ha sempre tag
		// configurati, essendo il requisito di base di questa board).
		changeTag(item, tag) {
			const payload = tag ? { _id: tag._id, label: tag.label, color: tag.color } : null;
			const body = { item, color: tag ? tag.color : null, tag: payload };
			this.setPreload(true);
			axios
				.post(`${this.getUrl}orders/updatestatus`, body, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.updateSnackbar({ color: 'success', text: 'Tag aggiornato', snackbar: true, mode: 'multi-line', timeout: 4000 });
					// spostamento ottimistico locale (niente refresh() qui): l'indice Atlas Search su cui
					// gira dispatch-orders impiega qualche istante a riflettere l'update appena fatto, e un
					// refresh immediato dopo il POST tornerebbe ancora dati vecchi, sovrascrivendo (e
					// vanificando) qualsiasi correzione locale con lo stato stale del backend.
					this.moveItemBetweenTabs(item, tag);
				})
				.catch(err => {
					const apiMessage = err.response?.data?.message;
					this.updateSnackbar({ color: 'error', text: apiMessage || err.message, snackbar: true, mode: 'multi-line', timeout: 5000 });
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		// sposta l'item tra gli array orders dei tab (mutando direttamente gli array dello store
		// dispatchOrders, gli stessi riferimenti esposti da tabs()) e aggiorna i conteggi in tab,
		// senza aspettare un refresh() che nell'immediato tornerebbe ancora dati non aggiornati.
		moveItemBetweenTabs(item, newTag) {
			const sourceTab = this.tabs.find(t => (t.orders || []).some(o => o._id === item._id));
			if (sourceTab) {
				const idx = sourceTab.orders.findIndex(o => o._id === item._id);
				sourceTab.orders.splice(idx, 1);
				if (sourceTab.pagination) {
					sourceTab.pagination.total = Math.max(0, (sourceTab.pagination.total || 0) - 1);
					sourceTab.pagination.total_page = Math.ceil(sourceTab.pagination.total / (sourceTab.pagination.per_page || this.tableOptions.itemsPerPage));
				}
			}

			const destTabId = newTag ? newTag._id : 'untagged';
			const destTab = this.tabs.find(t => t._id === destTabId);
			if (destTab) {
				item.Tag = newTag ? { _id: newTag._id, label: newTag.label, color: newTag.color } : null;
				destTab.orders.unshift(item);
				if (destTab.pagination) {
					destTab.pagination.total = (destTab.pagination.total || 0) + 1;
					destTab.pagination.total_page = Math.ceil(destTab.pagination.total / (destTab.pagination.per_page || this.tableOptions.itemsPerPage));
				}
			}
		},
		isDarkColor(hex) {
			return isDarkColor(hex);
		},
		// stesso elenco/require di order/Index.vue::getImageMarketplace, per coerenza visiva
		getImageMarketplace(img) {
			switch (img) {
				case 'Amazon':
					return require(`@/assets/images/Amazon.svg`);
				case 'Ebay':
					return require(`@/assets/images/Ebay.svg`);
				case 'Magento':
					return require(`@/assets/images/Magento.svg`);
				case 'Shopify':
					return require(`@/assets/images/framework/shopify.svg`);
				case 'Store':
					return require(`@/assets/images/store.svg`);
				case 'Cassa':
					return require(`@/assets/images/cassa.svg`);
				default:
					return require(`@/assets/images/flag/map.svg`);
			}
		},
		// bandierina nazione di spedizione, stesso metodo/asset di order/Index.vue::getImageFlag
		getImageFlag(shippingAddress) {
			try {
				return require(`@/assets/images/flag/${shippingAddress.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		// colore configurato dal tenant per lo stato (Impostazioni > Ordini), stesso dato usato da order/Index.vue
		getStatusColor(statusOrder) {
			if (statusOrder && statusOrder._id) {
				const colorSetting = _.find(this.getSetting?.status_order || [], { _id: statusOrder._id });
				return colorSetting ? colorSetting.color : '#FFFFFF';
			}
			return '#FFFFFF';
		},
		hasActivePackingList(item) {
			return _.size(item.id_packing_list) > 0;
		},
		isItemExpanded(item) {
			return this.expanded.some(i => i._id === item._id);
		},
		toggleExpand(item) {
			const idx = this.expanded.findIndex(i => i._id === item._id);
			if (idx === -1) {
				this.expanded.push(item);
			} else {
				this.expanded.splice(idx, 1);
			}
		},
		packingListOperator(item) {
			const pl = item.id_packing_list && item.id_packing_list[0];
			const lastLog = pl && _.size(pl.history) > 0 ? pl.history[0] : null;
			return lastLog ? lastLog.user : 'N.D.';
		},
		// avvio rapido: pagina di avvio con l'ordine della riga gia' scelto; la preparazione parte
		// (o riprende) da sola appena c'e' l'operatore, poi si passa al dettaglio. Indietro torna qui.
		openQuickStart(item) {
			openWithReturn(this, { path: '/packing-list/new', query: { order: item.OrderID } }, { label: "Torna all'evasione ordini" });
		},
		// apre la packing list gia' in corso per l'ordine come pagina; Indietro torna qui
		openEdit(item) {
			const pl = item.id_packing_list && item.id_packing_list[0];
			if (pl) this.apriPackingList(pl._id);
		},
		apriPackingList(id) {
			openWithReturn(this, { path: `/packing-list/${id}` }, { label: "Torna all'evasione ordini" });
		},
	},
};
</script>

<style scoped>
/* pulsanti-tag custom (non v-tabs): il click sull'index di Vuetify v-tabs saltava alla tab
   due posizioni dopo quella cliccata (bug di v-tabs con la lista dinamica di tag), qui il click
   imposta activeTab esplicitamente senza passare dalla logica interna di v-tabs. */
.dispatch-tab {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	font-weight: 500;
	font-size: 0.875rem;
	user-select: none;
	transition: background-color 0.15s, box-shadow 0.15s;
}

.dispatch-tab-dot {
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-right: 8px;
	flex-shrink: 0;
}

/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.dispatch-cards,
.dispatch-cards tr {
	display: block;
	width: 100%;
}
.dispatch-cards tr,
.dispatch-cards tr:hover {
	background: transparent !important;
}
.dispatch-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.dispatch-cards tr:first-child td {
	padding-top: 12px !important;
}
.dispatch-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.dispatch-cards tr + tr td {
	padding-top: 8px !important;
}
/* righe prodotto dentro la card espansa */
.dispatch-section {
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 4px;
}
.dispatch-line {
	background: #f7f8fa;
	border-radius: 6px;
	padding: 8px 10px;
	font-size: 14px;
}
.dispatch-line + .dispatch-line {
	margin-top: 6px;
}
.dispatch-kv {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.dispatch-kv span:last-child {
	color: rgba(0, 0, 0, 0.87);
	text-align: right;
	word-break: break-word;
}
</style>
